import React, { useState, useEffect } from 'react'
import { useRequest } from '../utils/hooks'
import ReactGA from 'react-ga'
import HeaderSearchComponent from '../components/HeaderSearchComponent'
import DialogSearch from './DialogSearch'
import DialogRecommendation from './DialogRecommendation'
import DialogBusiness from './DialogBusiness'
import DialogShare from './DialogShare'

const Header = ({
  searchParams,
  setSearchParams,
  setEstabelecimentosState,
  pagination,
  setPagination,
  pageProps,
}) => {
  const initialSearchState = {
    cidade: '',
    bairro: '',
    servico: 'none',
    servicoName: '',
    estabelecimento: '',
  }

  const [
    estabelecimentosCategorias,
    statusRequestEstabelecimentosCategorias,
    fetchEstabelecimentosCategorias,
  ] = useRequest(
    [],
    {
      url: `estabelecimentos/categorias`,
      method: 'get',
    },
    null
  )

  useEffect(() => {
    fetchEstabelecimentosCategorias()
  }, [])

  const [dialogSearch, setDialogSearch] = useState({
    isOpen: false,
    data: null,
  })
  const [dialogShare, setDialogShare] = useState({ isOpen: false, data: null })
  const [dialogRecommendation, setDialogRecommendation] = useState({
    isOpen: false,
    data: null,
  })
  const [dialogBusiness, setDialogBusiness] = useState({
    isOpen: false,
    data: null,
  })

  const [searchState, setSearchState] = useState({
    ...initialSearchState,
  })

  const search = (searchState) => {
    setPagination({ ...pagination, currentPage: 0 })
    setSearchParams(searchState)
    setDialogSearch({ isOpen: false, data: null })

    ReactGA.event({
      category: pageProps.title,
      action: 'Search button clicked',
    })
  }

  const clearSearch = () => {
    setPagination({ ...pagination, currentPage: 0 })
    search({})
    setEstabelecimentosState([])
    setSearchState({
      ...initialSearchState,
    })
  }

  return (
    <>
      <HeaderSearchComponent
        setDialogSearch={setDialogSearch}
        setDialogShare={setDialogShare}
        setDialogRecommendation={setDialogRecommendation}
        setDialogBusiness={setDialogBusiness}
        searchParams={searchParams}
        searchState={searchState}
        setSearchState={setSearchState}
        clearSearch={clearSearch}
        search={search}
        estabelecimentosCategorias={estabelecimentosCategorias || []}
      />

      {/* <DialogSearch
        dialog={dialogSearch}
        setDialog={setDialogSearch}
        search={search}
        clearSearch={clearSearch}
        searchState={searchState}
        setSearchState={setSearchState}
      /> */}

      <DialogRecommendation
        dialog={dialogRecommendation}
        setDialog={setDialogRecommendation}
      />
      <DialogBusiness dialog={dialogBusiness} setDialog={setDialogBusiness} />

      {/* <DialogShare dialog={dialogShare} setDialog={setDialogShare} /> */}
    </>
  )
}

export default Header
